<template>
    <div class="modal fade" id="ModalRegister" tabindex="-1" role="dialog" aria-labelledby="Обратная связь"
         aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="h5 heading heading_modal" id="ModalRegisterLabel" v-if="!message">РЕГИСТРАЦИЯ</p>
                    <button type="button" class="modal-close btn btn-close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"></span>
                    </button>
                </div>
                <div class="modal-body">
                    <form action="/ajax_new/Forms/register/" @submit.prevent="submit" v-if="!message" method="post">
<!--                        <label class="custom-control custom-radio">
                            <input :value="'F'" v-model="userType" type="radio"
                                   class="custom-control-input">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">Физическое лицо</span>
                        </label>
                        <label class="custom-control custom-radio">
                            <input :value="'U'" v-model="userType" type="radio"
                                   class="custom-control-input">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">Юридическое лицо</span>
                        </label>-->
                      <input type="hidden" name="recaptcha_token" value="">

                      <div class="modal-body-content modal-scroller">

                          <div class="mgc-error-alert alert alert-error">Заполните, пожалуйста, все обязательные поля ниже</div>

                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.firstName.$error }">
                                <label for="RegisterForm-firstName">
                                    Имя
                                    <span class="color-red">*</span>
                                </label>
                                <input type="text" class="form-control" id="RegisterForm-firstName" name="firstName"
                                       v-model.trim="$v.firstName.$model" @blur="$v.firstName.$touch()">
                                <div class="invalid-input" v-if="!$v.firstName.required">
                                    Поле обязательно для заполнения
                                </div>
                            </div>
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.lastName.$error }">
                                <label for="RegisterForm-lastName">
                                    Фамилия
                                    <span class="color-red">*</span>
                                </label>
                                <input type="text" class="form-control" id="RegisterForm-lastName" name="lastName"
                                       v-model.trim="$v.lastName.$model" @blur="$v.lastName.$touch()">
                                <div class="invalid-input" v-if="!$v.lastName.required">
                                    Поле обязательно для заполнения
                                </div>
                            </div>
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.email.$error }">
                                <label for="RegisterForm-email">
                                    Email
                                    <span class="color-red">*</span>
                                </label>
                                <input type="text" class="form-control" id="RegisterForm-email" name="email"
                                       v-model.trim="email" @input="setEmail($event.target.value)" @blur="checkValidEmail">
                                <div class="invalid-input" v-if="!$v.email.required">
                                    Поле обязательно для заполнения
                                </div>
                                <div class="invalid-input" v-if="!$v.email.email">
                                    Неверный e-mail
                                </div>
                                <div class="invalid-input" v-if="!$v.email.noUser && $v.email.email">
                                  Пользователь с таким email существует. <a href="#ModalForgotPass" data-dismiss="modal" data-toggle="modal" data-target="#ModalForgotPass">
                                  Восстановить пароль
                                </a>
                                </div>
                            </div>
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.password.$error }">
                                <label for="RegisterForm-password">
                                    Пароль
                                    <span class="color-red">*</span>
                                </label>
                              <div class="input-group">
                                <input  :type="showInput ? 'text' : 'password'"  class="form-control" id="RegisterForm-password" name="password"
                                       v-model.trim="password" @blur="$v.password.$touch()" @input="setPassword($event.target.value)">

                                <div @click="setText()"  class="input-group-addon">
                                  <i  v-if="!showInput" class="fa fas fa-eye"></i>
                                  <i   v-if="showInput" class="fa fas fa-eye-slash"></i>

                                </div>
                              </div>




                                <div class="invalid-input" v-if="!$v.password.required">
                                    Поле обязательно для заполнения
                                </div>
                                <div class="invalid-input" v-if="!$v.password.minLength">
                                    Минимальная длина пароля {{ $v.password.$params.minLength.min }}
                                </div>
                            </div>
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.passwordConfirm.$error }">
                                <label for="RegisterForm-passwordConfirm">
                                    Повторите пароль
                                    <span class="color-red">*</span>
                                </label>
                              <div class="input-group">
                                <input  :type="showInput ? 'text' : 'password'"   class="form-control" id="RegisterForm-passwordConfirm" name="passwordConfirm"
                                       v-model.trim="passwordConfirm" @blur="$v.passwordConfirm.$touch()" @input="setPasswordConfirm($event.target.value)">



                                <div @click="setText()"  class="input-group-addon">
                                  <i  v-if="!showInput" class="fa fas fa-eye"></i>
                                  <i   v-if="showInput" class="fa fas fa-eye-slash"></i>

                                </div>
                              </div>



                              <div class="invalid-input" v-if="!$v.passwordConfirm.required">
                                    Поле обязательно для заполнения
                                </div>
                                <div class="invalid-input" v-if="!$v.passwordConfirm.sameAsPassword">
                                    Пароли не совпадают
                                </div>
                            </div>
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.phone.$error }">
                                <label for="RegisterForm-phone">
                                    Телефон
                                    <span class="color-red">*</span>
                                </label>
                                <masked-input class="form-control"
                                              name="phone"
                                              mask="+7 (999) 999 99 99" placeholder="+7 (___) ___ __ __"
                                              type="tel"
                                              ref="maskedPhone"
                                              id="RegisterForm-phone"
                                              @focus="$v.phone.$reset"
                                              @blur="$v.phone.$touch"
                                              @input="setPhone"
                                              :value="phone"/>
                                <div class="invalid-input" v-if="!$v.phone.valid">
                                    Неверный номер телефона
                                </div>
                                <div class="invalid-input" v-if="!$v.phone.noUser && $v.phone.valid">
                                    Пользователь с таким номером существует <a href="#ModalForgotPass" data-dismiss="modal" data-toggle="modal" data-target="#ModalForgotPass">
                                  Восстановить пароль
                                </a>
                                </div>
                            </div>
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.code.$error }">
                                <label for="RegisterForm-code">
                                    Код из смс
                                    <span class="color-red">*</span>
                                </label>
                                <div class="input-group">
                                    <masked-input class="form-control"
                                                  id="RegisterForm-code"
                                                  mask="9999" placeholder="____"
                                                  @focus="$v.code.$reset"
                                                  @blur="$v.code.$touch"
                                                  :value="code"
                                                  type="text"
                                                  @input="setCode"
                                                  ref="maskedCode"/>
                                    <div class="input-group-append code-action" :class="{ 'code-success': $v.code.success }">
                                        <div v-if="$v.code.success" class="text-center">
                                            <span class="color-light-green"><i class="fa fa-check" aria-hidden="true"></i> Подтвержден</span>
                                        </div>
                                        <div v-if="!$v.code.success">
                                            <button v-if="codeTimer > 0" disabled="disabled" type="button" class="btn btn-primary">
                                                <span>{{codeTimer}}</span>
                                            </button>
                                            <button @click="sendCode" type="button" class="btn btn-primary">
                                                отправить код
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="invalid-input" v-if="!$v.code.valid || !$v.code.success">
                                  Введите код
                                </div>
                            </div>
<!--                            <suggest v-model="city" :init="cityInit" @blur="checkValidCity"
                                     :title="'Город'" @complete="val => cityValid = val">
                            </suggest>-->



                        </div>

                        <div class="form-group form-group_modal policy-personal-data-block">
                            Нажимая на кнопку «Зарегистрироваться» вы подтверждаете,
                            что согласны с
                            <a href="/policy-personal-data" class="policy-data" target="_blank">
                                Политикой обработки персональных данных
                            </a>
                        </div>
                        <div class="form-group form-group_modal mt-3 modal-footer">
                            <button v-loading="isAjax" :disabled="isAjax" type="submit" class="btn btn-primary btn-block">Зарегистрироваться</button>
                        </div>
                        <div class="alert alert-dismissable fade show alert-success" role="alert" v-if="message">
                            {{ message }}
                        </div>
                        <div class="alert alert-dismissable fade show alert-danger" role="alert" v-if="errors.length">
                            {{ errors[0].message }}
                        </div>
                    </form>
                    <div v-if="message">
                        <h3 class="py-3 text-center" v-if="message">
                            {{ message }}
                        </h3>
                        <div class="form-group form-group_modal">
                            <button class="btn btn-primary btn-block" data-dismiss="modal">ОК</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, email, minLength, sameAs} from 'vuelidate/lib/validators'
  import MaskedInput from '../MaskedInput'
  import Suggest from './components/Suggest'
  //import ForgotPass from "./ForgotPass.vue";

  export default {
    name: 'register',
    mixins: [validationMixin],
    components: {MaskedInput, Suggest},
    data: function () {
      return {

        showInput: false,
        userType: 'F',

        firstName: '',
        lastName: '',

        email: '',

        password: '',
        passwordConfirm: '',

        phone: '',

        isUser: false,

        code: '',
        isCodeSuccess: false,
        isCodeSend: false,
        codeTimer: 0,

        city: '',
        cityValid: false,
        cityInit: true,

        isAjax: false,
        isAjaxInn: false,

        organizationName: '',
        fullOrganizationName: '',
        legalAddress: '',
        bank: '',
        bik: '',
        correspondentAccount: '',
        checkingAccount: '',
        inn: '',
        kpp: '',

        organizationPhone: "",

        message: '',
        errors: []
      }
    },
    computed: {
      phoneValid() {
        if(this.phone.replace(/[^0-9]/g, '').length === 11) {
          this.checkUser('login')
          this.$v.code.$touch()
        }
        return this.phone.replace(/[^0-9]/g, '').length === 11
      },
      isOrgPhoneComplete () {
        return true;
        if(typeof this.organizationPhone!=="undefined" && this.organizationPhone.length>0)
        return this.organizationPhone.replace(/[^0-9]/g, '').length === 11
        else return false;
      },
      codeValid() {
        if (this.code.replace(/[^0-9]/g, '').length === 4) {
          this.checkCode()

          this.$v.code.$touch()
        }
        return this.code.replace(/[^0-9]/g, '').length === 4
      }
    },
    validations: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required,
        email,
        noUser () {
          return !this.isUser
        }
      },
      password: {
        required,
        minLength: minLength(6)
      },
      passwordConfirm: {
        required,
        sameAsPassword: sameAs('password')
      },
      phone: {
        valid () {
          return this.phoneValid
        },
        noUser () {
          return !this.isUser
        }
      },
      code: {
        valid () {
          return this.codeValid
        },
        success () {
          return this.isCodeSuccess
        }
      },
      organizationName: {

      },
      fullOrganizationName: {

      },
      legalAddress: {

      },
      bank: {

      },
      bik: {

      },
      correspondentAccount: {

      },
      checkingAccount: {

      },
      inn: {

      },
      kpp: {
       // required
      },

      validationGroupF: [
        'firstName',
        'lastName',
        'email',
        'password',
        'passwordConfirm',
        'phone',
        'code'
      ]
    },
    methods: {
      setText(){
        this.showInput = !this.showInput;
      },
      setCode (val) {
        this.code = val
      },
      setOrganizationPhone (val) {
        this.organizationPhone = val
      },
      checkValidCity: function () {
        this.cityInit = false
      },
      setPassword (value) {
        this.password = value
        this.$v.password.$reset()
      },
      setPasswordConfirm (value) {
        this.passwordConfirm = value
        this.$v.passwordConfirm.$reset()
      },
      setEmail (value) {
        this.isUser = false

        this.email = value
        this.$v.email.$reset()
      },
      checkValidEmail () {
        this.isUser = false

        this.$v.email.$touch()

        if (!this.$v.email.$invalid) {
          this.checkUser('email')
        }
      },
      setPhone: function (val) {
        this.phone = val
      },
      checkUser: function (type) {
        this.errors = []
        this.message = ''

        let userData = null
        let params = new FormData()

        if (type === 'login') {
          userData = this.phone.replace(/[^0-9.]/g, '').substr(1);
         // ForgotPass.methods.setPhone(userData);
          localStorage.setItem("_phone", userData);
          params.append('type', 'login')
        }
        if (type === 'email' && this.$v.email.email) {
          userData = this.email
          localStorage.setItem("_email", userData);
          params.append('type', 'email')
        }

        if (userData) {
          params.append('userData', userData)

          this.$http.post('/ajax_new/User/isUser/', params).then(request => {
            if (request.data.status) {
              this.isUser = true
            } else {
              this.isUser = false
            }
          }).catch(error => {
            console.error(error)
          })
        }
      },
      sendCode: function () {
        if (this.codeTimer > 0) {
          return
        }

        this.codeTimer = 0
        this.errors = []
        this.message = ''
        this.$v.phone.$touch()

        if (!this.$v.phone.$invalid) {
          this.isCodeSend = false

          let phone = this.phone.replace(/[^0-9.]/g, '').substr(1)

          let params = new FormData()
          params.append('phone', phone)
          params.append('type', 'register')

          this.$http.post('/ajax_new/Code/send/', params).then(request => {
            if (request.data.status) {
              this.isCodeSend = true
              this.codeTimer = 60
              window.setInterval(() => {
                if (this.codeTimer > 0) {
                  this.codeTimer--
                }
              }, 1000)
            } else {
              this.phoneValid = false
            }
          }).catch(error => {
            console.error(error)
          })
        }
      },
      checkCode: function () {
        this.errors = []
        this.message = ''
        this.$v.phone.$touch()

        if (!this.isCodeSend) {
          return
        }

        if (!this.$v.phone.$invalid) {
          let phone = this.phone.replace(/[^0-9.]/g, '').substr(1)

          let params = new FormData()
          params.append('phone', phone)
          params.append('code', this.code)
          params.append('type', 'register')

          this.$http.post('/ajax_new/Code/check/', params).then(request => {
            if (request.data.status) {
              this.isCodeSuccess = true
            } else {
              this.isCodeSuccess = false
            }
          }).catch(error => {
            console.error(error)
          })
        }
      },
      findByInn () {
        this.errors = []
        this.message = ''
        this.$v.inn.$touch()

        if (!this.$v.inn.$invalid) {
          let params = new FormData()
          params.append('inn', this.inn)

          this.isAjaxInn = true

          this.$http.post('/ajax_new/Dadata/findById/', params).then(request => {
            this.isAjaxInn = false

            if (request.data.status) {
              let result = request.data.data.result

              this.organizationName = result.organizationName
              this.fullOrganizationName = result.fullOrganizationName
              this.legalAddress = result.legalAddress
              this.organizationPhone = result.organizationPhone
              this.kpp = typeof result.kpp!=="undefined" ? result.kpp.toString() :""
            } else {
              this.errors = request.data.errors
            }
          })
        }
      },
       getOffset: function( el ) {
    var _x = 0;
    var _y = 0;

    while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
      _x += el.offsetLeft - el.scrollLeft;
      _y += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
    }
    return { top: _y, left: _x };
  },
      // form-group--error
      resetScrollPos:function(selector,selectorTo) {
    var divs = document.querySelectorAll(selector);
    let tox = 0;
    if(typeof  selectorTo!='undefined'){
      let divsTo =  document.querySelectorAll(selectorTo);
      if(typeof  divsTo!='undefined'){
     //   tox = this.getOffset(divsTo[0]).top;
      }
    }

    if ( divs.length>0) {
      if (Boolean(divs[0].style.transform)) { //for IE(10) and firefox
        divs[0].style.transform = 'translate3d('+tox+'px, 0px, 0px)';
      } else { //for chrome and safari
        divs[0].style['-webkit-transform'] = 'translate3d('+tox+'px, 0px, 0px)';
      }

      divs[0].scrollTop = tox ;
    }
  },
      submit: async function (e) {
        document.getElementsByClassName('mgc-error-alert')[0].style.display = 'none';
        this.errors = []
        this.message = ''

        let targetNode = e.target
        let action = targetNode.action

        let phone = this.phone.replace(/[^0-9.]/g, '').substr(1)

        if (!this.cityValid) {
          this.cityInit = false
        }

        if (this.userType === 'F') {
          this.$v.validationGroupF.$touch()

          if (this.$v.validationGroupF.$invalid) {

            document.getElementsByClassName('mgc-error-alert')[0].style.display = 'block';
            console.error("Invalid A");
            this.resetScrollPos('.modal-scroller','.form-group--error');
            return
          }
        } else {
          this.$v.$touch()

          if (this.$v.$invalid) {
            document.getElementsByClassName('mgc-error-alert')[0].style.display = 'block';
            this.resetScrollPos('.modal-scroller','.form-group--error');
            console.error("Invalid B")
            return
          }
        }

        let params = new FormData()
        params.append('userType', this.userType)
        params.append('firstName', this.firstName)
        params.append('lastName', this.lastName)
        params.append('lastName', this.lastName)
        params.append('email', this.email)
        params.append('password', this.password)
        params.append('passwordConfirm', this.passwordConfirm)
        params.append('phone', phone)
        params.append('city', this.city)

        params.append('organizationName', this.organizationName)
        params.append('fullOrganizationName', this.fullOrganizationName)
        params.append('legalAddress', this.legalAddress)



        if (this.isOrgPhoneComplete && this.userType === 'U') {

        /*  let organizationPhonez = "";
          if(typeof this.organizationPhone !== "undefined" &&  this.organizationPhone !== null)
             organizationPhonez = this.organizationPhone.replace(/[^0-9.]/g, '').substr(1)*/
        //  else return false;



          params.append('organizationPhone', this.organizationPhone)
        }

        params.append('bank', this.bank)
        params.append('bik', this.bik)
        params.append('correspondentAccount', this.correspondentAccount)
        params.append('checkingAccount', this.checkingAccount)
        params.append('inn', this.inn)
        params.append('kpp', this.kpp)

        this.isAjax = true

        await this.$recaptchaLoaded()
        const token = await this.$recaptcha('register')

        params.append('g-recaptcha-response', token)

        this.$http.post(action, params).then(request => {
          this.isAjax = false

          if (request.data.status) {
            window.location.href = request.data.data.redirect
          } else {
            this.errors = request.data.errors
          }
        }).catch(error => {
          console.error(error)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/forms/Register.vue